export default __webpack_public_path__ + "static/media/bootstrapper-4.07db2c3a.png";